<template>
  <div class="mode-switcher" v-show="activeModesCount > 1">
    <div class="space">
      <div
        :class="getTabClass('inside')"
        @click="switchMode('inside')"
        v-if="modes.inside && !cafe.inside_lite"
      >
        INSIDE
        <span :class="getCountClass('inside')" v-if="counters.inside"
          >({{ counters.inside }})</span
        >
      </div>

      <div
        :class="getTabClass('delivery')"
        @click="switchMode('delivery')"
        v-if="modes.delivery"
      >
        DELIVERY
        <span :class="getCountClass('delivery')" v-if="counters.delivery"
          >({{ counters.delivery }})</span
        >
      </div>
      <div
        :class="getTabClass('preorder')"
        @click="switchMode('preorder')"
        v-if="modes.preorder"
      >
        TAKEAWAY
        <span :class="getCountClass('preorder')" v-if="counters.preorder"
          >({{ counters.preorder }})</span
        >
      </div>
      <div
        :class="getTabClass('reserve')"
        @click="switchMode('reserve')"
        v-if="modes.reserve"
      >
        RESERVE
        <span :class="getCountClass('reserve')" v-if="counters.reserve"
          >({{ counters.reserve }})</span
        >
      </div>
      <div
        :class="getTabClass('hotels')"
        @click="switchMode('hotels')"
        v-if="modes.hotels"
      >
        ROOMS
        <span :class="getCountClass('hotels')" v-if="counters.hotels"
          >({{ counters.hotels }})</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    counters: Object,
    current: String,
    cafe: Object,
  },
  watch: {
    cafe() {
      this.checkModes();
    },
  },
  methods: {
    data() {
      return {
        showModeSwitcher: true,
      };
    },
    getTabClass(mode) {
      return {
        "mode-tab": true,
        'mode-tab-active': this.current == mode,
        "mode-tab-2-cols": this.activeModesCount == 2,
      };
    },
    getCountClass(mode) {
      return {
        "mode-count": true,
        // "mode-count-active": this.current == mode && !this.inArchive,
        "mode-count-active": !this.inArchive,
        'mode-count-active-white': this.inArchive && this.current == mode
      };
    },
    switchMode(mode) {
      this.$emit("switch", mode);
    },
    checkModes() {
      if (!this.cafe || !this.cafe.modes || this.$route.query.m) return;

      if (
        this.cafe.modes.inside &&
        this.cafe.activated &&
        !this.cafe.inside_lite
      ) {
        this.switchMode("inside");
      } else if (this.cafe.modes.delivery) {
        this.switchMode("delivery");
      } else if (this.cafe.modes.preorder) {
        this.switchMode("preorder");
      } else if (this.cafe.modes.hotels) {
        this.switchMode("hotels");
      }
    },
  },
  computed: {
    activeModesCount() {
      return this.$store.getters["activeModesCount"];
    },
    modes() {
      if (!this.cafe.modes)
        return {
          inside: false,
          preorder: false,
          delivery: false,
          hotels: false,
        };

      return this.cafe.modes;
    },
    isDesktop() {
      return window.innerWidth > 768;
    },
    inArchive() {
      return this.$route.name == 'archive';
    },
    isHotel() {
      return this.$store.getters.isHotel;
    }
  },
  mounted() {
    this.$store.dispatch('init')
    this.checkModes();
  },
};
</script>

<style scoped>
.mode-switcher {
  overflow: auto;
  position: relative;
  top: 7.7vh;

  background: transparent;

  z-index: 5;
  padding: 2.5vh 0 0 2vh;
  width: 100%;
  display: -webkit-box;
  overflow: scroll;
  padding: 2.5vh 0;
  width: auto;
  margin: 0vh auto;
}

.mode-tab {
  border-radius: 5vh;
  border: 1px solid #1d1d1b;
  color: #1d1d1b;
  background: #ededed;
  display: flex;
  justify-content: center;
  min-width: 19vh;
  margin: 0 0 0 2.5vh;
  padding: 0.8vh 2vh;
}

.space {
  display: flex;
  padding-right: 2.5vh;
  width: max-content;
  justify-content: space-evenly;
}

.mode-tab-2-cols {
  flex-basis: 50%;
}

/* .mode-tab-inside {
  background: #464646;
  color: #ededed;
}

.mode-tab-delivery {
  background: #cbd9e6 !important;
}

.mode-tab-preorder {
  background: #ffd2a8;
} */

.mode-tab-active {
  background: #1d1d1b !important;
  color: #ededed !important;
}

.mode-count-active {
  /* background: #1d1d1b !important; */
  color: #e2223b !important;
}

.mode-count-active-white {
  color: #ededed !important;
}

.mode-count {
  padding: 0.2vh 0.8vh;
  text-align: center;
  color: #1d1d1d;
  font-size: 1.7vh;
  display: flex;
  align-items: center;}
</style>
